import React from 'react';
import joinLeft from '../img/png/join_background_left.png';
import joinRight from '../img/png/join_background_right.png';
import map from '../img/png/map.png';

function JoinUs() {
  const onClick = () => {
    window.location.href = 'mailto:jobs@sqreem.com; info@sqreem.com';
  };
  return (
    <>
      <section
        id='careers'
        className='join d-flex align-items-center justify-content-center '
      >
        <div className='join_container d-flex align-items-center'>
          <div className='join_container_left flex-1'>
            <div className='d-flex align-items-center justify-content-center'>
              <img src={map} alt='background' />
            </div>
          </div>
          <div className='join_container_right flex-1'>
            <div className='d-flex-col gap-2 justify-content-center'>
              <h2 className='text-title'>Join our team</h2>
              <div className='d-flex-col gap-1'>
                <p className='text-gray'>
                  SQREEM serves hundreds of organizations across a broad
                  spectrum of verticals from offices in eight markets across the
                  globe, including Singapore, Tokyo, New York, Geneva
                  (Switzerland), London, Ho Chi Minh City, Manila, Hong Kong and
                  Auckland.
                </p>
                <p className='text-gray'>
                  We are hiring in our Singapore and London offices, and looking
                  for passionate Programmatic and AdTech specialists.
                </p>
              </div>
              <button onClick={onClick}>Apply here</button>
              <div className='line'></div>
            </div>
          </div>
        </div>
        <div className='join_background d-flex justify-content-between'>
          <div className='join_background_left d-flex align-items-center'>
            <img src={joinLeft} alt='background' />
          </div>
          <div className='join_background_right d-flex-col justify-content-start'>
            <img src={joinRight} alt='background' />
          </div>
        </div>
      </section>
    </>
  );
}

export default JoinUs;
